import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";


export class GamePeriodService {


    constructor() {
        this.httpClient = new HttpClient();
    }

    addNewGamePeriod(title, gameId, competitionStartDate, competitionEndDate, registrationStartDate, registrationEndDate, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `game-periods`,
                {
                    title,
                    gameId,
                    competitionStartDate:convertPersianDateToUniversalDate(competitionStartDate),
                    competitionEndDate:convertPersianDateToUniversalDate(competitionEndDate),
                    registrationStartDate:convertPersianDateToUniversalDate(registrationStartDate),
                    registrationEndDate:convertPersianDateToUniversalDate(registrationEndDate),
                    "type": type && type.length > 0 && type === "REGISTRATION" ? "REGISTRATION" : "OPERATION",
                }
            ).then(resolve).catch(reject)
        })

    }


    getGamePeriods(page, size, title) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/game-periods`,
                {page, size, title},
            ).then(resolve)
                .catch(reject)
        })
    }

    readBasicInformation(gamePeriodId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-periods/${gamePeriodId}/information`
            ).then(resolve).catch(reject)
        })
    }

    readRegistrationPeriod = (id) => {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-periods/${id}/registration-period`
            ).then(resolve).catch(reject)
        })
    }

    readCompetitionPeriod = (id) => {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-periods/${id}/competition-period`
            ).then(resolve).catch(reject)
        })
    }

    readAdmissionSetting = (id) => {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-periods/${id}/admission-settings`
            ).then(resolve).catch(reject)
        })
    }

    updateBasicInformation(id, title, description, rules) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-periods/${id}/information`,
                {},
                {
                    title, description, rules
                }
            ).then(resolve).catch(reject)
        })
    }

    updateGameRegistrationDate(gamePeriodId, startDate, endDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-periods/${gamePeriodId}/registration-period`,
                {},
                {
                    startDate,
                    endDate
                }
            ).then(resolve).catch(reject)
        })
    }

    updateGameCompetitionDate(gamePeriodId, startDate, endDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-periods/${gamePeriodId}/competition-period`,
                {},
                {
                    startDate,
                    endDate
                }
            ).then(resolve).catch(reject)
        })
    }

    updateGameAdmissionSetting(id, status) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-periods/${id}/admission-settings`,
                {},
                {
                    status
                }
            ).then(resolve).catch(reject)
        })
    }
}